import { THIRD_PARTY_COOKIE_NAME } from './config'

export const getCookieValue = (name: string): string | null => {
  return (
    document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() ??
    null
  )
}

export const isThirdPartyCookiesEnabled = (): boolean => {
  return getCookieValue(THIRD_PARTY_COOKIE_NAME) === '1'
}
